import { ExamData } from './examData';

/** Whitelist exam fields; the parser's unit metadata never enters ExamData. */
export function gripParserData(data: Record<string, unknown>): ExamData['grip_strength'] {
  const out: Record<string, number | 'pain' | 'effort' | null> = {
    limited_by: data.limited_by === 'pain' || data.limited_by === 'effort' ? data.limited_by : null,
  };
  for (const side of ['right', 'left']) {
    for (const trial of [1, 2, 3]) {
      const key = `${side}_attempt_${trial}`;
      const value = data[key];
      out[key] = typeof value === 'number' && Number.isFinite(value)
        ? data.unit === 'lb' ? Math.round(value * 0.4536 * 10) / 10 : value
        : null;
    }
  }
  return out as ExamData['grip_strength'];
}
